import {
  getPriceOptions,
  getSelectedPriceOptionId,
  getSelectedPriceValue,
  getSelectedZoneOptionId,
  getSelectedZoneValue,
  getZoneOptions,
} from '../../../../../selectors/seating/filters'
import {isInAccessibilityMode} from '../../../../../selectors/seating/mode'
import {getTickets} from '../../../../../selectors/tickets'
import {DetailsPageAppProps} from '../../../../app/interfaces'
import {connect} from '../../../../runtime-context/context'
import {Filters as Presentation} from './filters'
import {FiltersOwnProps, FiltersRuntimeProps} from './interfaces'

const mapRuntime = (
  {state, actions: {selectPrice, selectLocation}}: DetailsPageAppProps,
  {t, getTicketPriceText, getFormattedMoney}: FiltersOwnProps,
): FiltersRuntimeProps => {
  const priceOptions = getPriceOptions(getTickets(state), t, {getTicketPriceText, getFormattedMoney})
  const zoneOptions = getZoneOptions(state.seating.plan, t)

  const selectedPriceOptionId = getSelectedPriceOptionId(state, priceOptions)
  const selectedZoneOptionId = getSelectedZoneOptionId(state, zoneOptions)

  return {
    selectPrice,
    selectLocation,
    showAccessibilityMode: isInAccessibilityMode(state),
    priceOptions,
    zoneOptions,
    selectedPriceOptionId,
    selectedZoneOptionId,
    selectedPriceValue: getSelectedPriceValue(priceOptions, selectedPriceOptionId),
    selectedZoneValue: getSelectedZoneValue(zoneOptions, selectedZoneOptionId),
  }
}

export const Filters = connect<FiltersOwnProps, FiltersRuntimeProps>(mapRuntime)(Presentation)
export * from './interfaces'
